import { render, staticRenderFns } from "./storeDayStatistic.vue?vue&type=template&id=70701a76&scoped=true"
import script from "./storeDayStatistic.vue?vue&type=script&lang=js"
export * from "./storeDayStatistic.vue?vue&type=script&lang=js"
import style0 from "./storeDayStatistic.vue?vue&type=style&index=0&id=70701a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70701a76",
  null
  
)

export default component.exports